import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';
import { accessFunctions } from '../../shared/utilities/Constants';
import * as fromAuthorize from './authorize.reducers';

export const authorizeFeatureKey = 'authorizeKey';

export interface AuthorizeState { [fromAuthorize.authorizeKey]: fromAuthorize.State; }

export function reducers(state: AuthorizeState | undefined, action: Action) {
  return combineReducers({ [fromAuthorize.authorizeKey]: fromAuthorize.authorizeReducer })(state, action);
}

export const selectAuthorize = createFeatureSelector<AuthorizeState>(
  authorizeFeatureKey
);

export const selectAuthorizeState = createSelector(selectAuthorize, (state) => {
  return state?.authorize;
});

export const selectAuthorizeCallSuccessful = createSelector(selectAuthorizeState, (state) => {
  return state.authorizeCallSuccess;
});

export const selectAuthorizeCallFailed = createSelector(selectAuthorizeState, (state) => {
  return state.authorizeCallFailure;
});

export const selectHasAccessInitiateMoneyMovement = createSelector(selectAuthorizeState, (state) => {
  return state.accessFunctions[accessFunctions.accessInitiateMoneyMovement];
});

export const selectHasAccessReleaseMoneyMovement = createSelector(selectAuthorizeState, (state) => {
  return state.accessFunctions[accessFunctions.accessReleaseMoneyMovement];
});

export const selectHasUpdateMoveMoney = createSelector(selectAuthorizeState, (state) => {
  return state.accessFunctions[accessFunctions.updateMoveMoney];
});

export const selectHasViewMoveMoney = createSelector(selectAuthorizeState, (state) => {
  return state.accessFunctions[accessFunctions.viewMoveMoney];
});

export const selectHasUpdateMoneyLink = createSelector(selectAuthorizeState, (state) => {
  return state.accessFunctions[accessFunctions.updateMoneyLink];
});

export const selectHasMoveMoneyShell = createSelector(selectAuthorizeState, (state) => {
  return state.accessFunctions[accessFunctions.moveMoneyShellFirms];
});

export const selectHasPTRSViewFacility = createSelector(selectAuthorizeState, (state) => {
  return state.accessFunctions[accessFunctions.ptrsViewFacility];
});

export const selectHasRequestWire = createSelector(selectAuthorizeState, (state) => {
  return state.accessFunctions[accessFunctions.requestWire];
});

export const selectHasPositionJournalLotSelection = createSelector(selectAuthorizeState, (state) => {
  return state.accessFunctions[accessFunctions.journalPositionLotSelection];
});

export const selectHasEditAchPhase2 = createSelector(selectAuthorizeState, (state) => {
  return state.accessFunctions[accessFunctions.editAchPhase2];
});

export const selectHasDigitalToPdfTransactionAccess = createSelector(selectAuthorizeState, (state) => {
  return state?.accessFunctions[accessFunctions.accessDigitalToPdfTransactions];
});

export const selectHasPositionLotsPhase2 = createSelector(selectAuthorizeState, (state) => {
  return state?.accessFunctions[accessFunctions.accessPositionLotsPhase2];
});

export const selectPalWiresEnabled = createSelector(selectAuthorizeState, (state) => {
  return state?.accessFunctions[accessFunctions.accessPalWires];
});

export const selectAchPathEnabled = createSelector(selectAuthorizeState, (state) => {
  return state?.accessFunctions[accessFunctions.accessAchPath];
});
